import { c as _c } from "react/compiler-runtime";
import { FC } from 'react';
interface Props {
  data: object | null;
}

// Escaping "<" prevents XSS via </script> breakout when CMS-sourced strings
// land in dangerouslySetInnerHTML (see Next.js JSON-LD guide).
const JsonLdScript: FC<Props> = t0 => {
  const $ = _c(5);
  const {
    data
  } = t0;
  if (!data) {
    return null;
  }
  let t1;
  if ($[0] !== data) {
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = /</g;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    t1 = JSON.stringify(data).replace(t2, "\\u003c");
    $[0] = data;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <script type="application/ld+json" dangerouslySetInnerHTML={{
      __html: t1
    }} />;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
export default JsonLdScript;